(function() {
    'use strict';

    angular.module('doclr.user', ['doclr.praktijk', 'doclr.resources.api', 'ui.bootstrap', 'doclr.disciplines'])
        .config(function($stateProvider) {
            $stateProvider
                .state('wijzigpaswoord', {
                    url: '/wijzig-paswoord',
                    templateUrl: '/partials/user/wijzigpaswoord.html',
                    controller: function($scope, $state, $window, $http, userContext) {
                        $scope.username = userContext.username;

                        $scope.terug = function() {
                            $state.go('agenda.initial');
                        };

                        $scope.wijzigPaswoord = function() {
                            $http.post('/api/user/password', {oldPassword: $scope.oudPaswoord, newPassword: $scope.nieuwPaswoord})
                                .then(function() {
                                    $window.location.href = '/login#/?infoMessage=wachtwoordGewijzigd';
                                });
                        };
                    }
                }).state('wijziggegevens', {
                    url: '/wijzig-gegevens',
                    templateUrl: '/partials/user/wijziggegevens.html',
                    resolve: {
                        agendas: function(AgendaOverzicht, praktijkContext) {
                            return AgendaOverzicht.get(praktijkContext.id);
                        },
                        praktijken: function(Users) {
                            return Users.getPraktijken();
                        },
                        token: function(Users, userContext,praktijkContext) {
                            return Users.getToken(userContext.id, praktijkContext.id);
                        },
                        rolNames : function(Rolnames){
                            return Rolnames.getList();
                        }
                    },
                    controller: function($scope, $state, $window, $http, userContext, agendas, praktijken, Users,
                                         rolNames, notificationService,token) {
                        var gegevens = {};
                        gegevens.username = userContext.username;
                        gegevens.naam = userContext.naam;
                        gegevens.voornaam = userContext.voornaam;
                        gegevens.rolnaam = userContext.rolnaam;
                        gegevens.defaultAgendaId = userContext.defaultAgendaId;
                        gegevens.defaultPraktijkId = userContext.defaultPraktijkId;
                        gegevens.krijgEmail = userContext.krijgEmail;
                        gegevens.praktijkId = userContext.praktijkId;
                        gegevens.calendarHoursVisibility = userContext.calendarHoursVisibility;
                        gegevens.appointmentStarthourVisible = userContext.appointmentStarthourVisible;
                        gegevens.holidayVisible = userContext.holidayVisible;
                        gegevens.vacationVisible = userContext.vacationVisible;
                        $scope.gegevens = gegevens;
                        $scope.rolNames = rolNames;
                        $scope.agendas = agendas;
                        $scope.praktijken = praktijken;
                        $scope.token = token;


                        $scope.calendarHoursVisibilities = ['Left', 'Right', 'LeftAndRight', 'BetweenCalendars'];

                        $scope.terug = function() {
                            $state.go('agenda.initial');
                        };

                        $scope.wijzig = function() {
                            var defaultAgendaId = gegevens.defaultAgendaId ? gegevens.defaultAgendaId.split('/').pop() : null;
                            Users.save({voornaam: gegevens.voornaam,
                                naam: gegevens.naam,
                                rolnaam: gegevens.rolnaam,
                                defaultAgendaId: defaultAgendaId,
                                defaultPraktijkId: gegevens.defaultPraktijkId,
                                krijgEmail: gegevens.krijgEmail,
                                praktijkId: gegevens.praktijkId,
                                calendarHoursVisibility: gegevens.calendarHoursVisibility,
                                appointmentStarthourVisible: gegevens.appointmentStarthourVisible,
                                vacationVisible: gegevens.vacationVisible,
                                holidayVisible: gegevens.holidayVisible
                                })
                                .then(function() {
                                    angular.extend(userContext, gegevens);
                                    notificationService.showSuccess(doclrVertaal.instant('partials.user.wijziguser.userChangedMessage'));
                                    $state.go('agenda.initial');
                                });
                        };
                    }
                })
                .state('gebruikersbeheer', {
                    url: '/gebruikersbeheer',
                    resolve: {
                        users: function(Users, praktijkContext) {
                            return Users.getList(praktijkContext.id);
                        }
                    },
                    views : {
                        '' : {
                            templateUrl : '/partials/components/page.with.sidebar.html'
                        },
                        'content@gebruikersbeheer' : {
                            templateUrl: '/partials/user/gebruikersbeheer.html',
                            controller: function($scope, $state, users,userContext) {
                                $scope.users = users;
                                $scope.isAdminUser = userContext.admin;
                                $scope.ontzegToegangPraktijk = function(user) {
                                    $scope.userToDelete = user;
                                    $state.go('gebruikersbeheer.ontzegtoegangtotpraktijk');
                                };

                                $scope.verwijderToken = function(user) {
                                    $scope.userId = user.id.replace('/api/user/','');
                                    $scope.praktijkId = user.praktijkId;
                                    $state.go('gebruikersbeheer.verwijderToken');
                                };

                                $scope.toonToken = function(user) {
                                    $state.go('gebruikersbeheer.toonToken',{userId:user.id.replace('/api/user/','')});
                                };

                                $scope.maakToken = function(user) {
                                    $scope.userId = user.id.replace('/api/user/','');
                                    $scope.praktijkId = user.praktijkId;
                                    $state.go('gebruikersbeheer.maakToken');
                                };
                                $scope.maakAangepastToken = function(user) {
                                    $scope.userId = user.id.replace('/api/user/','');
                                    $scope.praktijkId = user.praktijkId;
                                    $state.go('gebruikersbeheer.maakAangepastToken');
                                };
                            }
                        },
                        'sidebar@gebruikersbeheer' : {
                            templateUrl: '/partials/user/gebruikersbeheer.sidebar.html',
                            controller: function($scope, $state) {

                                $scope.createNew = function() {
                                    $state.go('nieuweuser');
                                };

                            }
                        }
                    }
                })

                .state('gebruikersbeheer.ontzegtoegangtotpraktijk', {
                    controller: function($scope, $uibModal, $stateParams, $state, Users, notificationService) {
                        $scope.confirmmodal  = {
                            title : doclrVertaal.instant('partials.user.wijziguser.userDenyAccessTitle'),
                            question : doclrVertaal.instant('partials.user.wijziguser.userDenyAccessMessage')
                        };

                        var modalInstance = $uibModal.open({
                            templateUrl: '/partials/components/confirmmodal.html',
                            scope : $scope
                        });

                        modalInstance.result.then(function() {
                            Users.ontzegToegangPraktijk($scope.userToDelete).then(function() {
                                notificationService.showSuccess(doclrVertaal.instant('partials.user.wijziguser.userDeletedMessage'));
                                $scope.users.splice($scope.users.indexOf($scope.userToDelete), 1);
                            });
                        }, function() {
                            $state.go('^');
                        });
                    }
                })

                .state('gebruikersbeheer.maakToken', {
                    controller: function($scope, $uibModal, $stateParams, $state, Users, notificationService) {
                        $scope.confirmmodal  = {
                            title : doclrVertaal.instant('partials.user.wijziguser.createTokenTitle'),
                            question : doclrVertaal.instant('partials.user.wijziguser.createTokenMessage')
                        };

                        var modalInstance = $uibModal.open({
                            templateUrl: '/partials/components/confirmmodal.html',
                            scope : $scope
                        });

                        modalInstance.result.then(function() {
                            Users.maakToken($scope.userId, $scope.praktijkId).then(function() {
                                notificationService.showSuccess(doclrVertaal.instant('partials.user.wijziguser.tokenCreatedMessage'));
                                $state.go('^', {}, {reload: true});
                            });
                        }, function() {
                            $state.go('^');
                        });
                    }
                })

                .state('gebruikersbeheer.maakAangepastToken', {
                    controller: function($scope, $uibModal, $stateParams, $state, Users, notificationService) {
                        $scope.model  = {
                            token : ''
                        };

                        $uibModal.open({
                            templateUrl: '/partials/user/aangepasttokenaanmaken.html',
                            scope : $scope
                        });

                        $scope.maakAangepastToken = function() {
                            Users.maakAangepastToken($scope.userId, $scope.model.token, $scope.praktijkId).then(function() {
                                notificationService.showSuccess(doclrVertaal.instant('partials.user.wijziguser.tokenCreatedMessage'));
                                $state.go('^', {}, {reload: true});
                            });
                        };
                    }
                })

                .state('gebruikersbeheer.verwijderToken', {
                    controller: function($scope, $uibModal, $stateParams, $state, Users, notificationService) {
                        $scope.confirmmodal  = {
                            title : doclrVertaal.instant('partials.user.wijziguser.deleteTokenTitle'),
                            question : doclrVertaal.instant('partials.user.wijziguser.deleteTokenMessage')
                        };

                        var modalInstance = $uibModal.open({
                            templateUrl: '/partials/components/confirmmodal.html',
                            scope : $scope
                        });

                        modalInstance.result.then(function() {
                            Users.verwijderToken($scope.userId, $scope.praktijkId).then(function() {
                                notificationService.showSuccess(doclrVertaal.instant('partials.user.wijziguser.tokenDeletedMessage'));
                                $state.go('^', {}, {reload: true});
                            });
                        }, function() {
                            $state.go('^');
                        });
                    }
                })

                .state('gebruikersbeheer.toonToken', {
                    params: {userId:null},
                    resolve: {
                        token: function(Users, praktijkContext,$stateParams) {
                            return Users.getToken($stateParams.userId, praktijkContext.id);
                        }
                    },

                    controller: function($scope, $uibModal, $stateParams, $state, Users, notificationService, token) {
                        $scope.simplemodal  = {
                            title : 'Token voor gebruiker',
                            message : token
                        };

                        var modalInstance = $uibModal.open({
                            templateUrl: '/partials/components/simplemodal.html',
                            scope : $scope
                        });

                        modalInstance.result.then(function() {
                            $state.go('^');
                        }, function() {
                            $state.go('^');
                        });
                    }
                })

                .state('nieuweuser', {
                    url: '/nieuwe-user',
                    templateUrl: '/partials/user/nieuweuser.html',
                    resolve: {
                        disciplineList: function (Disciplines) {
                            return Disciplines.getList();
                        },
                        rolNames : function(Rolnames){
                            return Rolnames.getList();
                        }
                    },
                    controller: function($scope, $state, praktijkContext, Users, notificationService, rolNames, disciplineList) {
                        $scope.disciplineList = disciplineList;
                        $scope.rolNames = rolNames;
                        $scope.terug = function() {
                            $state.go('gebruikersbeheer');
                        };

                        $scope.nieuweUser = function() {
                            Users.nieuweUser(praktijkContext.id, $scope.email, $scope.voornaam, $scope.naam, $scope.rolnaam)
                                .then(function() {
                                    notificationService.showSuccess(doclrVertaal.instant('partials.user.wijziguser.userCreatedMessage'));
                                    $state.go('gebruikersbeheer');
                                });
                        };

                    }
                });
        })
        /*
         from: https://github.com/angular-app/angular-app

         The MIT License

         Copyright (c) 2012 Pawel Kozlowski & Peter Bacon Darwin

         Permission is hereby granted, free of charge, to any person obtaining a copy
         of this software and associated documentation files (the "Software"), to deal
         in the Software without restriction, including without limitation the rights
         to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         copies of the Software, and to permit persons to whom the Software is
         furnished to do so, subject to the following conditions:

         The above copyright notice and this permission notice shall be included in
         all copies or substantial portions of the Software.

         THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         THE SOFTWARE.
         */
        .directive('validateEquals', function() {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, elm, attrs, ctrl) {

                    function validateEqual(myValue, otherValue) {
                        if (myValue === otherValue) {
                            ctrl.$setValidity('equal', true);
                            return myValue;
                        } else {
                            ctrl.$setValidity('equal', false);
                            return undefined;
                        }
                    }

                    scope.$watch(attrs.validateEquals, function(otherModelValue) {
                        ctrl.$setValidity('equal', ctrl.$viewValue === otherModelValue);
                    });

                    ctrl.$parsers.push(function(viewValue) {
                        return validateEqual(viewValue, scope.$eval(attrs.validateEquals));
                    });

                    ctrl.$formatters.push(function(modelValue) {
                        return validateEqual(modelValue, scope.$eval(attrs.validateEquals));
                    });
                }
            };
        });
})();
